import { useState, useEffect, useCallback } from 'react';

/**
 * Custom hook to detect if a given media query matches the current viewport.
 * @param {string} query - The CSS media query string (e.g., "(max-width: 590px)").
 * @returns {boolean} - True if the media query matches, false otherwise.
 */
const useMediaQuery = (query) => {
  const [matches, setMatches] = useState(false);

  const handleChange = useCallback((e) => {
    setMatches(e.matches);
  }, []);

  useEffect(() => {
    // Check for browser environment
    if (typeof window === 'undefined' || !window.matchMedia) {
      console.warn("useMediaQuery: window.matchMedia is not supported in this environment.");
      return;
    }

    const mediaQueryList = window.matchMedia(query);

    // Set initial state
    setMatches(mediaQueryList.matches);

    // Listen for changes
    mediaQueryList.addEventListener('change', handleChange);

    // Cleanup listener
    return () => {
      mediaQueryList.removeEventListener('change', handleChange);
    };
  }, [query, handleChange]);

  return matches;
};

export default useMediaQuery;